import {Component, ViewChild, EventEmitter} from '@angular/core';
import {MatPaginator, MatDialog, MatSort} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {generalService} from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import {ItemFamily} from '../../models/item-family';
import {DataSourceGrid,datosGrid} from '../../utils/sourceGrid.component';
import { FormGroup, FormBuilder, FormControl, Validators  } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'item-family-add-edit',
  styleUrls: [],
  templateUrl: 'item-family-add-edit.component.html',
  providers: [generalService]
})

export class ItemFamiliaAddEditComponent {
  // --------- VARIABLES MATERIALES -------------//
  familyAgregar: FormGroup;
  public family:ItemFamily;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public isUpdate:boolean=false;
  public itemFamilyID:any; 

  private readonly SUCCESS_MSG = 'Se ha guardado exitosamente!';
  private readonly UPDATE_MS = 'Se actualizó exitosamente!';
  
  //----------- Listas (mat-select)-------------//
  public familiaLista:any=[];
  public subFamiliaLista:any=[];


  constructor(private _generalService: generalService, public dialog: MatDialog, public dataService: DataService/*, private sanitizer: DomSanitizer*/, private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute) {
    this.family = new ItemFamily();
    this.itemFamilyID = this.route.snapshot.paramMap.get('id');    
  }

  async ngOnInit() {
    this.buildForm();
    await this.cargarPantalla();
    this.validateRoute();
    this.family.companyId = this.userData.COMPANY_ID;

  }

  buildForm(){
    this.familyAgregar = this.formBuilder.group({
        familiaCtrl: this.formBuilder.control(null, Validators.required),
        idFamilyCtrl: this.formBuilder.control(null),
      });
  }

  cargarPantalla(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.requestGet("venta/cargarInformacionAgregarVenta?idUsuario=" + this.userData.USER_ID).subscribe(
        (result) => {
            var dataTemp: any = JSON.parse(result);
            // Tipo de venta
            //this.lstTipoVenta = dataTemp.Table1;
            // ----------------------   COMPRA   ------------------------ //
            // Familias
            this.familiaLista = dataTemp.Table2;
            this.family.lstFamilia = this.familiaLista;                        
            // Subfamilias
            this.subFamiliaLista = dataTemp.Table3;
            this.family.lstSubFamilia = this.subFamiliaLista;
          
            resolve();
        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
            reject();
        }
    );

    });
  }

  validateRoute() {
    if (this.itemFamilyID === 'N') {
      this.isUpdate = false;      
    } else if (parseInt(this.itemFamilyID)) {
      this.isUpdate = true;
      this.consultItem(this.itemFamilyID);
    } else {
      this.router.navigate(['item-family/N']);
    }
  }

  consultItem(itemFamilyID:any){
    var params = {
      userID: this.userData.USER_ID,
      familyID: itemFamilyID
    }
    this._generalService.metodoCallParams(params, 'itemFamily/consultaFamily/')
      .subscribe(products => {
        var result = JSON.parse(products);
        if (result.length > 0) {
          this.family.itemFamilyId = result[0].ITEM_FAMILY_ID;
          this.family.name = result[0].NAME;
          this.family.companyId = result[0].COMPANY_ID;
        } 
      }, error => {
        // Custom error handler
      });
  }
  
  agregar() {
    let tipo = 'agregar';
    let metodo = 'itemFamily/insertItemFamily/';
    
    var params = {
      ItemFamilyId: undefined,
      NAME:this.family.name, 
      CompanyId : this.family.companyId
    };

    this._generalService.metodoCallParamsPutPost(tipo, params, metodo).subscribe(
      (result) => {
        if (result == '') {
          this._generalService.toastCall(this.SUCCESS_MSG);
        } else {
          this.dataService.guardado = true;
        }
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  update() {
    if(this.isUpdate){
      //this.product.loacs = sessionStorage.getItem("acslo");
      var params = {
        ItemFamilyId: this.family.itemFamilyId,
        NAME:this.family.name, 
        CompanyId : this.family.companyId
      };
      this._generalService.metodoCallParams(params, 'itemFamily/updateItemFamily/')
        .subscribe(result => {
          if (result == '') {
            this._generalService.toastCall(this.UPDATE_MS)
          } else {
            this.dataService.guardado = true;
          }
        }, error => {
          // Custom error handler
          const errorMsj =  error as any;
          console.log(errorMsj);
        });
    }
  }

  regresar(){
    this.router.navigate(['app/item-family']);
  }


}//fin de export class




// WEBPACK FOOTER //
// ./src/app/familia/add-edit/item-family-add-edit.component.ts